// The preferred-provider ribbon (Figma "Icon_PreferredProviders"). Not StarIcon (which marks the owner) or
// AcceptedPlanIcon (which marks an accepted health plan), since a provider can carry either of those
// alongside this one. Defaults to currentColor so it follows the nav's active state.
export default function AwardIcon({
  width = 14,
  height = 14,
  color = 'currentColor',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.15095 13.9029L4.59173 13.1193L6.56798 9.60587C6.71032 9.61852 6.8544 9.625 7 9.625C7.14554 9.625 7.28951 9.61852 7.43178 9.60587L9.40806 13.1193L9.84883 13.9029L10.3848 13.181L11.2927 11.9583H13.8336L13.3408 11.0876L11.1597 7.23409C11.5747 6.52277 11.8125 5.69542 11.8125 4.8125C11.8125 2.15463 9.65784 0 7 0C4.34213 0 2.1875 2.15463 2.1875 4.8125C2.1875 5.69533 2.42521 6.52266 2.84013 7.23392L0.65898 11.0876L0.166199 11.9583H2.70706L3.61496 13.181L4.15095 13.9029ZM7 8.16667C5.14754 8.16667 3.64583 6.66493 3.64583 4.8125C3.64583 2.96004 5.14754 1.45833 7 1.45833C8.85243 1.45833 10.3542 2.96004 10.3542 4.8125C10.3542 6.66493 8.85243 8.16667 7 8.16667ZM7.69539 3.97193L7 2.7798L6.30455 3.97193L5.02741 4.3649L5.88548 5.22299L5.59291 6.68593L7 6.05115L8.40706 6.68593L8.11446 5.22299L8.97254 4.3649L7.69539 3.97193Z'
        fill={color}
      />
    </svg>
  );
}
